<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="75%">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          class="primary text-capitalize f-14 lh-17 mt-2 mr-3"
          :class="isFormProfile ? 'mt-6' : 'mt-2'"
        >
          {{ isDetail ? 'Show' : 'Select' }} Channel & Account
        </v-btn>
        <v-col cols="12" class="pa-0" :class="isFormProfile ? 'mt-0' : 'mt-2'">
          <span class="red--text caption" v-if="!isFormProfile">
            {{ validationMessage }}
          </span>
          <span v-if="account.length > 0 || isFormProfile" class="caption">
            {{ account.length }} Account selected.
          </span>
        </v-col>
      </template>
      <v-card class="rounded-12">
        <v-card-title
          class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6"
        >
          <img
            src="@/assets/images/icon/filter.png"
            width="20px"
            class="mr-3"
          />
          <span class="pa-0">
            {{ isDetail ? 'Show' : 'Select' }} Channel & Account
          </span>
          <v-spacer></v-spacer>
          <v-icon
            @click="dialog = false"
            color="white"
            class="fs-18"
            style="font-size: 20px !important; margin-right: -4px !important"
          >
            close
          </v-icon>
        </v-card-title>
        <v-perfect-scroll
          class="drawer-menu--scroll-dialog"
          :settings="scrollSettingsFilter"
        >
          <v-card-text class="pb-0 px-3 py-0 border-b-1">
            <v-container class="py-0 form-filter" v-if="itemList.length > 0">
              <v-flex xs12 class="pa-0">
                <v-row>
                  <v-col class="pt-4 pb-0">
                    <v-checkbox
                      v-model="selectAllChannel"
                      label="Select All Channel"
                      @change="selectChannel"
                      :disabled="isDetail"
                      color="menuActive"
                      hide-details
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col class="pt-4 pb-0" v-if="channelSelected.length > 0">
                    <v-checkbox
                      v-model="selectAllAccount"
                      label="Select All Account"
                      @change="selectAccount"
                      :disabled="isDetail"
                      color="menuActive"
                      hide-details
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-flex>
              <v-flex
                xs12
                class="pa-0"
                v-for="(channel, idxChannel) in itemList"
                :key="'ch-' + idxChannel"
              >
                <v-row class="border-b-1 py-3">
                  <v-col
                    class="pt-4"
                    v-for="(itemGroup, indexGroup) in channel.listGroup"
                    :key="'itemgroup-' + indexGroup"
                    :class="indexGroup !== 0 ? 'border-l-1' : ''"
                  >
                    <h4 class="primary--text lh-17 mb-3 ml-1">
                      {{ itemGroup.name }}
                    </h4>
                    <v-perfect-scroll
                      class="drawer-menu--scroll-filter"
                      :settings="scrollSettingsFilter"
                    >
                      <div style="margin-left: -5px;">
                        <v-checkbox
                          v-for="(subgroup, indexList) in itemGroup.listGroup"
                          :key="'subgroup' + indexList"
                          v-model="subgroup.isSelected"
                          :label="subgroup.name"
                          :disabled="isDetail"
                          @change="
                            getDetail(
                              channel,
                              idxChannel,
                              indexGroup,
                              itemGroup
                            )
                          "
                          color="menuActive"
                          class="pl-1"
                        >
                        </v-checkbox>
                      </div>
                    </v-perfect-scroll>
                  </v-col>
                </v-row>
                <!-- </v-perfect-scroll> -->
              </v-flex>
            </v-container>
            <v-container v-else-if="itemList.length === 0">
              <v-flex
                xs12
                class="text-center textlightgrey--text pt-10"
                style="height: 130px"
              >
                No data displayed
              </v-flex>
            </v-container>
          </v-card-text>
        </v-perfect-scroll>
        <v-card-actions class="py-3 px-6" v-if="!isDetail">
          <v-btn
            color="primary"
            dark
            class="rounded-6 text-capitalize px-4"
            @click="resetData()"
          >
            Reset
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="rounded-6 text-capitalize px-4"
            dark
            @click="parseData()"
          >
            Save
          </v-btn>
        </v-card-actions>
        <v-fade-transition>
          <v-overlay v-if="progressDialogLoading" absolute>
            <div class="preloader-content">
              <img
                src="@/assets/images/loading.gif"
                style="width: 170%"
                alt="preloader"
              />
            </div>
          </v-overlay>
        </v-fade-transition>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import LoginAsMixin from '@/mixins/LoginAsMixin';

export default {
  props: {
    account: {
      type: Array,
      default: () => []
    },
    channel: {
      type: Array,
      default: () => []
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    isFormProfile: {
      type: Boolean,
      default: false
    }
  },
  mixins: [LoginAsMixin],
  data() {
    return {
      progressDialogLoading: false,
      dialog: false,
      objSelected: [],
      scrollSettingsFilter: {
        maxScrollbarLength: 283
      },
      itemList: [],
      accountSelected: [],
      selectAllChannel: false,
      selectAllAccount: false,
      tempAccount: null,
      totalAccount: 0
    };
  },
  mounted() {
    this.getChannel();
  },
  computed: {
    validationMessage() {
      if (this.account.length === 0) {
        return 'Please select at least one Account!';
      } else {
        return '';
      }
    },
    channelSelected() {
      // ambil data yang selected nya true
      let params = this.itemList.map(listCard => {
        let tempListGroup = listCard.listGroup
          .filter(e => e != null)
          .map(listGroup => {
            return listGroup.listGroup.filter(list => {
              return list.isSelected === true && list.type === 'Channel';
            });
          });
        return tempListGroup.filter(tempList => {
          return tempList.length > 0;
        });
      });
      // filter yang arraynya adaan
      let paramFilter = params.filter(param => {
        return param.length > 0;
      });
      return paramFilter;
    },
    totalChannel() {
      // ambil data yang selected nya true
      let params = this.itemList.map(listCard => {
        let tempListGroup = listCard.listGroup
          .filter(e => e != null)
          .map(listGroup => {
            return listGroup.listGroup.filter(list => {
              return list.isSelected === true && list.type === 'Channel';
            });
          });
        return tempListGroup.filter(tempList => {
          return tempList.length > 0;
        });
      });
      return params.length;
    }
  },
  watch: {
    account() {
      if (this.account.length === 0) {
        this.getChannel();
      }
    },
    itemList: {
      handler() {
        this.countTotalAccount();
        this.countAccountSelected();
        this.setSelectAll();
      },
      deep: true
    }
  },
  methods: {
    setSelectAll() {
      this.selectAllChannel =
        this.channelSelected.length === this.totalChannel ? true : false;
      this.selectAllAccount =
        this.accountSelected.length === this.totalAccount ? true : false;
    },
    resetData() {
      this.$emit('update:account', []);
      this.$emit('update:channel', []);
      // this.getChannel();
    },
    getChannel() {
      this.selectAllChannel = false;
      this.selectAllAccount = false;
      this.progressDialogLoading = true;

      let endpoint = this.isLoggedInAsBO
        ? 'channel/getByProfile'
        : 'channel/getAll';
      let params = {
        paginate: false
      };
      let paramsBO = {
        id: this.isLoggedInAsBO ? localStorage.getItem('profile_id') : null,
        params: params
      };
      return this.$store
        .dispatch(endpoint, this.isLoggedInAsBO ? paramsBO : params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.itemList = [];
            this.itemList = data.data.map(channel => {
              this.tempAccount = null;
              if (
                this.channel.length > 0 &&
                this.channel.map(item => item.id).includes(channel.id)
              ) {
                this.tempAccount = {
                  id: this.account
                    .map(item => item.account.channel_id)
                    .filter(item => item === channel.id),
                  name: 'Account',
                  listGroup: channel.account.map(account => {
                    return {
                      ...account,
                      isSelected: this.account
                        .map(item => item.account.id)
                        .includes(account.id),
                      type: 'Account'
                    };
                  })
                };
              }
              return {
                account: channel.account,
                listGroup: [
                  {
                    id: channel.id,
                    name: 'Channel',
                    listGroup: [
                      {
                        id: channel.id,
                        name: channel.name,
                        isSelected:
                          this.channel.length > 0
                            ? this.channel
                                .map(item => item.id)
                                .includes(channel.id)
                            : false,
                        type: 'Channel'
                      }
                    ]
                  },
                  this.tempAccount
                ]
              };
            });
            this.itemList = this.itemList.map(listCard => {
              return {
                ...listCard,
                listGroup: listCard.listGroup.filter(e => e != null)
              };
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log('err', err);
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    getDetail(itemParent, idxChannel, indexGroup, listGroup) {
      // ambil data yang diceklis
      let selected = listGroup.listGroup
        .filter(selectedFiltered => {
          return selectedFiltered.isSelected === true;
        })
        .map(isSelected => {
          return isSelected.id;
        });
      if (selected.length > 0 && listGroup.name.toLowerCase() === 'channel') {
        //cari index card (divisi)
        let indexCard = idxChannel;
        if (indexGroup >= 0) {
          // hapus group dibawahnya
          let listgroup = this.itemList[indexCard].listGroup.slice(
            0,
            indexGroup + 1
          );
          this.itemList[indexCard].listGroup = listgroup;
        }
        // push group baru
        itemParent.listGroup.push({
          name: 'Account',
          listGroup: itemParent.account.map(result => {
            return {
              ...result,
              isSelected: false,
              type: 'Account'
            };
          })
        });
      } else if (listGroup.name.toLowerCase() === 'channel') {
        itemParent.listGroup.length = 1;
      }
    },
    selectChannel() {
      if (this.selectAllChannel) {
        // ubah data semua channel selected jadi true
        let itemList = this.itemList.map(listCard => {
          return {
            ...listCard,
            listGroup: listCard.listGroup.map(listGroup => {
              return {
                ...listGroup,
                listGroup: listGroup.listGroup.map(list => {
                  return {
                    ...list,
                    isSelected:
                      this.selectAllChannel && listGroup.name === 'Channel'
                        ? true
                        : false
                  };
                })
              };
            })
          };
        });
        this.itemList = itemList;
        // push list account
        for (let i = 0; i < this.itemList.length; i++) {
          if (this.itemList[i].listGroup.length === 1) {
            this.itemList[i].listGroup.push({
              name: 'Account',
              listGroup: this.itemList[i].account.map(result => {
                return {
                  ...result,
                  isSelected: false,
                  type: 'Account'
                };
              })
            });
          }
        }
      } else {
        this.resetData();
        this.getChannel();
      }
    },
    selectAccount() {
      // ubah data semua account selected jadi true
      let itemList = this.itemList.map(listCard => {
        return {
          ...listCard,
          listGroup: listCard.listGroup.map(listGroup => {
            // pilih hanya name nya account saja yang diubah value nya
            if (listGroup.name === 'Account') {
              return {
                ...listGroup,
                listGroup: listGroup.listGroup.map(list => {
                  return {
                    ...list,
                    isSelected:
                      this.selectAllAccount && listGroup.name === 'Account'
                        ? true
                        : false
                  };
                })
              };
            } else {
              return listGroup;
            }
          })
        };
      });
      this.itemList = itemList;
    },
    parseData() {
      let tempPush = [];
      let listChannel = [];
      // ambil data yang selected nya true
      let params = this.itemList.map(listCard => {
        let tempListGroup = listCard.listGroup.map(listGroup => {
          return listGroup.listGroup.filter(list => {
            return list.isSelected === true;
          });
        });
        return tempListGroup.filter(tempList => {
          return tempList.length > 0;
        });
      });
      // filter yang arraynya adaan
      let paramFilter = params.filter(param => {
        return param.length > 0;
      });
      //ambil level paling pertama yang dipilih
      let paramFilterFirst = paramFilter.map(param => {
        return param[0];
      });
      for (let a = 0; a < paramFilterFirst.length; a++) {
        for (let b = 0; b < paramFilterFirst[a].length; b++) {
          listChannel.push(paramFilterFirst[a][b]);
        }
      }
      //ambil level paling akhir yang dipilih
      let paramFilterLast = paramFilter.map(param => {
        return param[param.length - 1];
      });
      //push array of object
      for (let a = 0; a < paramFilterLast.length; a++) {
        for (let b = 0; b < paramFilterLast[a].length; b++) {
          tempPush.push(paramFilterLast[a][b]);
        }
      }
      // filter hanya account saja yg dipilih
      let accountSelected = this.copy(tempPush).filter(
        item => item.type !== 'Channel'
      );
      // filter hanya channel yang mempunyai account saja
      let filterChannel = [];
      for (let x = 0; x < listChannel.length; x++) {
        for (let i = 0; i < accountSelected.length; i++) {
          if (listChannel[x].id === accountSelected[i].channel_id) {
            filterChannel.push(listChannel[x]);
          }
        }
      }
      this.dialog = false;
      this.$emit('saveChannel', {
        account: accountSelected,
        channel: filterChannel.filter(
          (item, index) => filterChannel.indexOf(item) === index
        ),
        info: paramFilter
      });
    },
    countTotalAccount() {
      // ambil data yang selected account nya true
      let itemList = this.itemList.map(listCard => {
        let tempListGroup = listCard.listGroup
          .filter(e => e != null)
          .map(listGroup => {
            return listGroup.listGroup.filter(list => {
              return list.type === 'Account';
            });
          });
        return tempListGroup.filter(tempList => {
          return tempList.length > 0;
        });
      });
      //ambil level paling akhir yang dipilih
      let account = itemList.map(param => {
        return param[param.length - 1] || [];
      });
      //push array of object
      let tempPush = [];
      for (let a = 0; a < account.length; a++) {
        for (let b = 0; b < account[a].length; b++) {
          tempPush.push(account[a][b]);
        }
      }
      this.totalAccount = tempPush.length;
    },
    countAccountSelected() {
      // ambil data yang selected nya true
      let itemList = this.itemList.map(listCard => {
        let tempListGroup = listCard.listGroup
          .filter(e => e != null)
          .map(listGroup => {
            return listGroup.listGroup.filter(list => {
              return list.isSelected === true && list.type === 'Account';
            });
          });
        return tempListGroup.filter(tempList => {
          return tempList.length > 0;
        });
      });
      //ambil level paling akhir yang dipilih
      let account = itemList.map(param => {
        return param[param.length - 1] || [];
      });
      //push array of object
      let tempPush = [];
      for (let a = 0; a < account.length; a++) {
        for (let b = 0; b < account[a].length; b++) {
          tempPush.push(account[a][b]);
        }
      }
      this.accountSelected = tempPush;
    }
  }
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.drawer-menu--scroll-dialog {
  max-height: 450px;
  overflow: auto;
}
.drawer-menu--scroll-filter {
  max-height: 350px;
  overflow: auto;
}
.drawer-menu--scroll-vertical {
  max-width: 95%;
  overflow-x: auto;
}
v-dialog {
  overflow-y: hidden !important;
}
.preloader-content {
  position: absolute;
  top: 50%;
  width: 50px;
  left: 0;
  right: 0;
  margin: 0 auto;
  margin-top: -50px;
}
</style>
